import { createAsyncThunk } from '@reduxjs/toolkit';
import { errorGlobal, successGlobal } from '../reducers/notifications';
import { getAuthHeader } from '../../utils/tools';
import axios from 'axios';

axios.defaults.headers.post['Content-Type'] = 'application/json';

// Fetch warehouses
export const fetchWarehouses = createAsyncThunk(
    'branch/fetchWarehouses',
    async(currentBranch, {dispatch}) => {
        try {
            const request = await axios.get(`/api/warehouse/`, {
                    params: { branchId: currentBranch },
                    ...getAuthHeader()
                },
            );
            return request.data;
        } catch(error) {
            dispatch(errorGlobal('Sklad sa nepodarilo načítať.'));
            throw error;
        }
    }
);

// Edit warehouse
export const editWarehouse = createAsyncThunk(
    'branch/editWarehouses',
    async(data, {dispatch}) => {
        try {
            const { branchId, warehouse, newWarehouse } = data;
            const request = await axios.patch(`/api/warehouse/edit`, 
                { 
                    branchId,
                    warehouse,
                    newWarehouse 
                },
                getAuthHeader()
            );

            dispatch(successGlobal('Sklad bol úspešne upravený.'));
            return request.data;

        } catch(error) {
            dispatch(errorGlobal('Sklad sa nepodarilo upraviť.'));
            throw error;
        }
    }
);

// Add warehouse
export const addWarehouse = createAsyncThunk(
    'branch/addWarehouses',
    async(data, {dispatch}) => {
        try {
            const { branchId, warehouse } = data;
            const request = await axios.post(`/api/warehouse/create`, 
                { 
                    branchId,
                    warehouse,
                },
                getAuthHeader()
            );

            dispatch(successGlobal('Sklad bol úspešne vytvorený.'));
            return request.data;

        } catch(error) {
            dispatch(errorGlobal('Sklad sa nepodarilo vytvoriť.'));
            throw error;
        }
    }
);

// Check if warehouse exists in branch
export const checkWarehouseExists = createAsyncThunk(
    'branch/checkWarehouseExists',
    async({ branchId, warehouse}, { rejectWithValue } ) => {
        try {

            const response = await axios.post(`/api/warehouse/check-warehouse`,
                {
                    branchId,
                    warehouse
                },
                getAuthHeader()
            );

            return response.data.exists;

        } catch(error) {
            return rejectWithValue(error.response.data);
        }
    }
);

// Delete warehouse
export const deleteWarehouse = createAsyncThunk(
    'branch/deleteWarehouse',
async({branchId, warehouse}, { dispatch } ) => {
        try {
            const request = await axios.delete(`/api/warehouse/delete`, {
                params: {
                        branchId,
                        warehouse
                    },
                    ...getAuthHeader()
                }
            );
            
            dispatch(successGlobal('Sklad bol úspešne vymazaný.'));
            return request.data;

        } catch(error) {
            dispatch(errorGlobal('Sklad sa nepodarilo vymazať.'));
            throw error;
        }
    }
);